import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { Seo } from './components/Seo';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { Unveiling } from './components/Unveiling';
import { Waitlist } from './components/Waitlist';
import { Product } from './components/Product';
import { Flavors } from './components/Flavors';
import { Sensory } from './components/Sensory';
import { AboutTarta } from './components/AboutTarta';
import { LocalLaunch } from './components/LocalLaunch';
import { PreOrder } from './components/PreOrder';
import { Instagram } from './components/Instagram';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="28sbbj465l56n">
      <Seo data-id="element-1" data-mp="23vchsmqej08z" />
      <div className="min-h-screen bg-chocolate text-cream" data-id="element-2" data-mp="23vkzcrxgytqi">
        <Header data-id="element-3" data-mp="23t8i6gzjcnei" />
        <main data-id="element-4" data-mp="3ijxpqrsp22kf">
          <Unveiling data-id="element-5" data-mp="3ik7k0rkruvvx" />
          <Hero data-id="element-6" data-mp="3iiweam7rne26" />
          <Marquee data-id="element-7" data-mp="3ijfx0558q6h9" />
          <Product data-id="element-8" data-mp="3ihv2ugmu8pjx" />
          <Flavors data-id="element-9" data-mp="3mlj82snzz920" />
          <Sensory data-id="element-10" data-mp="3ml1234bj9ggw" />
          <AboutTarta data-id="element-11" data-mp="3mkhofzsx1e8o" />
          <Waitlist data-id="element-12" data-mp="3mjq2zht18ww4" />
          <LocalLaunch data-id="element-13" data-mp="3mj6jhwnqi0fz" />
          <PreOrder data-id="element-14" data-mp="3rbrakqf99zft" />
          <Instagram data-id="element-15" data-mp="3rdar8i4tqci4" />
          <FAQ data-id="element-16" data-mp="3rd1bdndhtlq5" />
          <FinalCTA data-id="element-17" data-mp="3recbnd7qcbci" />
        </main>
        <Footer data-id="element-18" data-mp="6hovayao7c0" />
      </div>
    </LanguageProvider>;
}